// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2fVT9","footer":"ModalError_footer__5w0aX"};